<template>
  <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" append-to-body :show-close="false" 
    :destroy-on-close="true" custom-class="equip-detail-dialog" top="60px" width="90vw" @close="closeDialog">
    <iframe v-if="dialogVisible" id="iframe-equip-detail" :src="iframeUrl" frameborder="0" class=""
      style="width:100%;height:800px; margin-bottom: -3px;"></iframe>
  </el-dialog>
</template>

<script>
import { getAccessToken } from "@/utils/cookie";
import store from '@/store/store'

export default {
  name: "FEquipDetail",

  data() {
    return {
      iframeUrl: "",
      dialogVisible: false,
    }
  },

  created() {
    
  },

  mounted() {
    var _this = this;
    // 接收rms的数据
    window.addEventListener("message", this.handleFrameMessage, false);
  },

 beforeDestroy() {
    window.removeEventListener("message", this.handleFrameMessage);
  },

  methods: {
    handleClose() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    open(id) {
      this.dialogVisible = true
      store.commit("visit",false)
      const source = encodeURIComponent(window.location.href);
      const accessToken = encodeURIComponent(getAccessToken());
      this.iframeUrl = `${process.env.VUE_APP_RMS_HOST}/#/home/detail?equipid=${Number(id)}&access_token=${accessToken}&source=${source}&openMethod=dialog`;
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handleFrameMessage(e) {
      if (e.origin !== process.env.VUE_APP_RMS_HOST) return;
      const { type } = e.data;
      if(type == 'close') {
        store.commit("visit",true)
        store.commit("SET_TAG",e.data.refreshTag)
        store.commit("SET_GROUP",e.data.refreshGroup)
        this.closeDialog()
      }else if(type == 'open_ap_detail') {
        const { simid } = e.data;
        this.$detail({type:'ap',id:simid})
      }
    },
  }
}
</script>

<style lang="scss">
.el-dialog.equip-detail-dialog {
  height: 90vh;
  max-width: 1500px;
  max-height: 800px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

}
</style>
